<template>
    <div class="crm-auth-connect">
        <div class="connect-grid" :class="{ 'connect-grid--single': instructionOnly }">
            <div v-if="!instructionOnly" class="panel pad instruction-panel">
                <div v-if="title || subtitle || kind || badge" class="section-title">
                    <div>
                        <span v-if="kind" class="eyebrow">{{ kind }}</span>
                        <h2 v-if="title">{{ title }}</h2>
                        <p v-if="subtitle">{{ subtitle }}</p>
                    </div>
                    <span v-if="badge" class="crm-badge">{{ badge }}</span>
                </div>

                <div v-if="tasks.length" class="task-list">
                    <div v-for="(task, idx) in tasks" :key="idx" class="task">
                        <b>{{ String(idx + 1).padStart(2, '0') }}</b>
                        <div>
                            <strong>{{ task.title }}</strong>
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <span v-if="task.body" v-html="task.body" />
                        </div>
                    </div>
                </div>

                <div v-if="showSupport" class="support-row">
                    <div class="support-copy">
                        <strong>Если нужно что-то уточнить, напишите в техподдержку Data Heroes:</strong>
                        <span>
                            <a
                                href="https://t.me/dataheroes_bot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >Telegram</a>
                            или
                            <a
                                href="https://max.ru/id7707452371_bot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >MAX</a>
                        </span>
                    </div>
                </div>
            </div>

            <aside class="panel pad data-card">
                <div>
                    <h3>{{ formTitle }}</h3>
                    <p v-if="formText">{{ formText }}</p>
                </div>
                <div class="field-stack">
                    <slot />
                </div>
            </aside>
        </div>

        <div v-if="showFallbackActions" class="crm-auth-fallback-actions">
            <v-btn
                v-if="canBack"
                color="white"
                class="black--text"
                :disabled="backDisabled || nextLoading"
                @click="$emit('back')"
            >
                {{ backLabel }}
            </v-btn>
            <v-btn
                color="mainNew"
                class="white--text"
                :disabled="nextDisabled"
                :loading="nextLoading"
                @click="$emit('next')"
            >
                {{ nextLabel }}
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CrmAuthConnectLayout',
    props: {
        kind: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        badge: {
            type: String,
            default: '',
        },
        tasks: {
            type: Array,
            default: () => [],
        },
        formTitle: {
            type: String,
            default: '',
        },
        formText: {
            type: String,
            default: '',
        },
        instructionOnly: {
            type: Boolean,
            default: false,
        },
        showSupport: {
            type: Boolean,
            default: true,
        },
        showFallbackActions: {
            type: Boolean,
            default: false,
        },
        canBack: {
            type: Boolean,
            default: true,
        },
        backLabel: {
            type: String,
            default: 'Назад',
        },
        nextLabel: {
            type: String,
            default: 'Далее',
        },
        nextDisabled: {
            type: Boolean,
            default: false,
        },
        backDisabled: {
            type: Boolean,
            default: false,
        },
        nextLoading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.crm-auth-connect
    width: 100%
    max-width: 100%
    min-width: 0
    margin-top: 0 !important
    display: grid
    gap: 18px
    box-sizing: border-box

.connect-grid
    display: grid
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.8fr)
    gap: 18px
    align-items: start
    width: 100%
    max-width: 100%
    min-width: 0
    box-sizing: border-box
    &--single
        grid-template-columns: minmax(0, 520px)
        justify-content: center

.panel
    width: 100%
    max-width: 100%
    min-width: 0
    border: 1px solid $border-new
    border-radius: 22px
    background: #fff
    box-shadow: 0 12px 32px rgba(26, 26, 46, 0.06)
    box-sizing: border-box
    &.pad
        padding: 24px

.instruction-panel
    display: grid
    gap: 16px
    align-content: start
    min-width: 0

.section-title
    display: flex
    align-items: flex-start
    justify-content: space-between
    gap: 16px
    margin-bottom: 4px
    min-width: 0
    > div
        min-width: 0
        max-width: 100%
    h2
        font-size: 22px
        letter-spacing: -.04em
        line-height: 1.1
        margin: 0
        font-weight: 800
        color: $dark-new
        overflow-wrap: anywhere
    p
        margin: 8px 0 0
        color: $muted-new
        font-size: 13px
        max-width: 100%
        line-height: 1.5
        overflow-wrap: anywhere

.eyebrow
    display: inline-flex
    align-items: center
    gap: 6px
    margin-bottom: 10px
    color: $main-new
    font-size: 11px
    font-weight: 900
    text-transform: uppercase
    letter-spacing: .14em

.crm-badge
    display: inline-flex
    align-items: center
    justify-content: center
    height: 28px
    padding: 0 10px
    border-radius: 999px
    background: #EEF0FF
    color: $main-new
    font-size: 11px
    font-weight: 800
    white-space: nowrap
    flex-shrink: 0

.task-list
    display: grid
    gap: 12px
    min-width: 0

.task
    display: grid
    grid-template-columns: 40px minmax(0, 1fr)
    gap: 12px
    align-items: start
    border: 1px solid $border-new
    border-radius: 16px
    padding: 14px
    background: #fff
    min-width: 0
    box-sizing: border-box
    b
        width: 40px
        height: 32px
        border-radius: 12px
        background: #EEF0FF
        color: $main-new
        display: grid
        place-items: center
        font-size: 12px
        font-weight: 900
        flex-shrink: 0
    > div
        min-width: 0
    strong
        display: block
        font-size: 14px
        margin-bottom: 3px
        letter-spacing: -.02em
        color: $dark-new
        overflow-wrap: anywhere
    ::v-deep span
        display: block
        color: $muted-new
        font-size: 13px
        line-height: 1.5
        overflow-wrap: anywhere
        word-break: break-word
        a
            color: $main-new
            font-weight: 900
            overflow-wrap: anywhere
            word-break: break-all

.support-row
    margin-top: 2px
    padding: 14px 16px
    border: 1px solid $border-new
    border-radius: 16px
    background: linear-gradient(180deg, #FAFBFF 0%, #F5F7FF 100%)
    min-width: 0
    box-sizing: border-box

.support-copy
    display: grid
    gap: 6px
    min-width: 0
    strong
        display: block
        font-size: 13px
        letter-spacing: -.02em
        color: $dark-new
        font-weight: 800
        overflow-wrap: anywhere
    span
        display: block
        color: $muted-new
        font-size: 13px
        line-height: 1.45
        overflow-wrap: anywhere
    a
        color: #2F8CFF
        font-weight: 900
        text-decoration: underline
        text-decoration-thickness: 1px
        text-underline-offset: 3px
        &:hover
            color: $main-new

.data-card
    display: grid
    grid-template-rows: auto auto
    gap: 16px
    align-content: start
    align-self: start
    min-width: 0
    h3
        font-size: 18px
        margin: 0
        letter-spacing: -.04em
        font-weight: 800
        color: $dark-new
        overflow-wrap: anywhere
    p
        margin: 8px 0 0
        color: $muted-new
        font-size: 13px
        line-height: 1.55
        overflow-wrap: anywhere

.field-stack
    display: grid
    gap: 14px
    align-content: start
    min-width: 0
    max-width: 100%

.crm-auth-fallback-actions
    margin-top: 4px
    display: flex
    gap: 16px
    flex-wrap: wrap
    justify-content: flex-start

@media (max-width: 980px)
    .connect-grid
        grid-template-columns: 1fr
    .connect-grid--single
        grid-template-columns: 1fr

@media (max-width: 700px)
    .section-title
        flex-direction: column
        align-items: flex-start
        gap: 10px
        h2
            font-size: 20px
    .panel.pad
        padding: 16px
        border-radius: 18px
    .task
        grid-template-columns: 36px minmax(0, 1fr)
        gap: 10px
        padding: 12px
        b
            width: 36px
            height: 30px
            font-size: 11px
    .crm-auth-fallback-actions
        flex-direction: column
        > *
            width: 100%
</style>
